/**
 * Platform Configuration
 * Centralized settings for the Party Rental Suite platform
 */

// Platform domain (used for subdomain URLs)
export const PLATFORM_DOMAIN = process.env.REACT_APP_PLATFORM_DOMAIN || "partyrentalsuite.com";

// Hostnames (substring match, comma-separated) that are dev/preview hosts rather than tenant
// domains — e.g. "onrender.com,preview.example.com". localhost is always a dev host.
const DEV_HOSTS = (process.env.REACT_APP_DEV_HOSTS || "").split(",").map(h => h.trim().toLowerCase()).filter(Boolean);
export const isDevHostname = (host = window.location.hostname) => {
  const h = host.toLowerCase();
  return h === "localhost" || h === "127.0.0.1" || DEV_HOSTS.some(d => h.includes(d));
};

// Build full subdomain URL
export const getSubdomainUrl = (subdomain) => {
  if (!subdomain) return null;
  return `https://${subdomain}.${PLATFORM_DOMAIN}`;
};

// Check if we're in preview/development environment
export const isPreviewEnvironment = () => isDevHostname();

// Get the live site URL for a microsite
export const getLiveSiteUrl = (microsite) => {
  if (!microsite) return null;
  
  // Priority: custom_domain > subdomain
  if (microsite.custom_domain || microsite.primary_domain) {
    return `https://${microsite.custom_domain || microsite.primary_domain}`;
  }
  
  if (microsite.subdomain) {
    // In preview environment, use /s/{subdomain} for clean URLs
    if (isPreviewEnvironment()) {
      return `${window.location.origin}/s/${microsite.subdomain}`;
    }
    // In production, use actual subdomain
    return getSubdomainUrl(microsite.subdomain);
  }
  
  // Fallback to /preview for theme demos
  return `${window.location.origin}/preview`;
};

// DNS instructions for custom domain
export const getDnsInstructions = (domain) => {
  return {
    type: "CNAME",
    name: domain,
    value: `proxy.${PLATFORM_DOMAIN}`,
    ttl: 3600,
  };
};

export default {
  PLATFORM_DOMAIN,
  getSubdomainUrl,
  isPreviewEnvironment,
  getLiveSiteUrl,
  getDnsInstructions,
};
